import { useState, useEffect, useRef } from "react";
import "./Login.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { userLoginAction } from "../../Redux/actions/authAction";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import logogg from "../../assets/img/logo gg.png";
import loginbg from "../../assets/img/loginbg.jpg";
import ROUTES from "../../docRoutes/docRoutes";
import { userInfoAction } from "../../Redux/actions/userInfoAction";
import { useFetch } from "../../Services/useFetch";
import { Input } from "antd";
import {
  fetchAuthMode,
  getAuthErrorMessage,
  isSsoAutoRedirectError,
  isSsoNoAccessError,
  ssoLoginUrl,
  ssoNoAccessUrl,
} from "../../utils/docGridSso";
const initialState = {
  username: "",
  password: "",
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  var _ = require("lodash");
  const { request } = useFetch();
  const [data, setData] = useState(initialState);
  const emailInputRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(true);

  const [showPassword, setShowPassword] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  // Set by the backend SSO callback or SsoComplete when a central sign-in
  // failed (which stops the idp-mode auto-redirect, so it cannot loop between
  // this page and the IDP), or by a logout whose session ended.
  const authError = new URLSearchParams(window.location.search).get("authError");
  const [authMode, setAuthMode] = useState("native");
  const [errorMessage, setErrorMessage] = useState(getAuthErrorMessage(authError));
  const [message, setMessage] = useState("");

  const checkAuth = async () => {
    let authForLogin = localStorage.getItem("docGridToken");
    if (authForLogin) {
      const currentPath = window.location.pathname;
      if (currentPath === ROUTES?.LOGIN || "/") {
        navigate(ROUTES?.BRIEFCASE, { replace: true });
      }
    } else {
      const mode = await fetchAuthMode();
      // idp mode never shows this page unless a sign-in just failed: the user
      // goes straight to the central login (stays on the blank loading
      // screen meanwhile). replace keeps this page out of the history, so
      // Back from the central login does not land here again.
      if (mode === "idp" && isSsoAutoRedirectError(authError)) {
        window.location.replace(ssoLoginUrl);
        return;
      }
      if (mode === "idp" && isSsoNoAccessError(authError)) {
        window.location.replace(ssoNoAccessUrl);
        return;
      }
      setAuthMode(mode);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    // setPassword(e.target.value);
    setDisableBtn(data.username === "" || data.password === "");
    setErrorMessage("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e?.preventDefault();
    }
  };

  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setDisableBtn(true);
    if (data.username === "" && data.password === "") {
      notify("please fill all the fields");
    } else if (data.username === "") {
      notify("please fill email");
    } else if (data.password === "") {
      notify("please fill password");
    } else {
      setLoader(true);
      const addBidGridLoginDetails = new URLSearchParams();
      addBidGridLoginDetails.append("username", data?.username);
      addBidGridLoginDetails.append("password", data?.password);

      if (localStorage.getItem("setfirebasetoken")) {
        addBidGridLoginDetails.append("web_push_notification_token", localStorage.getItem("setfirebasetoken"));
      }
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        addBidGridLoginDetails.append("ip_Adress", data.ip);

        const res = await request("/user-login", "post", addBidGridLoginDetails, {
          "Content-Type": "application/x-www-form-urlencoded",
        });

        if (res?.data?.status === "1") {
          dispatch(userLoginAction(res?.data));
          localStorage.setItem("docGridToken", res?.data?.token);
          const formData = new URLSearchParams();
          formData.append("user_id", Number(res?.data?.data?.id));
          try {
            // const response = await ProfileDetails.getuserdetails(formData);
            const response = await request("/user-details-edit", "post", formData, {
              "Content-Type": "application/x-www-form-urlencoded",
            });

            if (response?.data?.status == 1) {
              const userBidInfoData = response.data.data;
              dispatch(
                userInfoAction({
                  ...userBidInfoData,
                  // Add other properties from userBidInfo as needed
                })
              );
              navigate(ROUTES.BRIEFCASE);
              notifySuccess(res?.data?.message);
            } else {
              notify(response?.response?.data?.message);
            }
          } catch (error) {
            console.log(error, "api error");
          }
        } else {
          console.log(res?.message);
          setLoader(false);
          notify("Your login credentials are invalid");
        }
      } catch (error) {
        notify(error);
        setLoader(false);
        console.log(error);
      }
    }

    setTimeout(() => {
      setLoader(false);
      setDisableBtn(false);
    }, 2000);
  };

  const handleCheckMsg = () => {
    const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    if (data.username.length === 0) {
      setMessage("");
    }
    if (data.username !== "") {
      if (emailRegex.test(data.username)) {
        setMessage("");
      } else {
        setMessage("Please enter a valid email!");
      }
    }
  };

  useEffect(() => {
    if (emailInputRef.current) {
      emailInputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    handleCheckMsg();
  }, [data?.username]);

  useEffect(() => {
    setDisableBtn(false);
  }, [data.username, data.password]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    checkAuth();
  }, []);

  // Back from the IDP can restore this page from the back/forward cache as it
  // was when it left for the IDP (still loading, so blank): check again.
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) checkAuth();
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  if (loading) return <div className="login_body"></div>;
  return (
    <>
      <div className="login_body">
        <div className="leftSide">
          <img src={loginbg} width={"100%"} alt="" style={{ objectFit: "cover", height: "100%" }} />
        </div>

        <div className="formWarpper">
          <div className="loginLogo">
            <img src={logogg} width={100} alt="" />
          </div>

          <div className="section-title text-center">
            <h1>
              DocGrid Login <span className="one-text"></span>
            </h1>
          </div>
          <div className="errormessagename" style={{ color: "red-600" }}>
            {errorMessage}
          </div>

          {authMode === "idp" ? (
            <div className="form">
              <button type="button" className="mainButton" onClick={() => window.location.assign(ssoLoginUrl)}>
                Sign in with central login
              </button>
            </div>
          ) : (
          <form className="form" method="" action="" onSubmit={handleSubmit}>
            <div className="inputGrp">
              <Input
                onInput={handleChange}
                ref={emailInputRef}
                autoComplete="off"
                onKeyDown={handleKeyDown}
                value={data?.username}
                className="form__input"
                name="username"
                type="email"
                placeholder="Enter Email"
              />
              <div className="message" style={{ color: "#dc2626" }}>
                {message}
              </div>
              <div className="eye_position">
                <Input
                  onInput={handleChange}
                  onKeyDown={handleKeyDown}
                  autoComplete="off"
                  value={data?.password}
                  className="form__input"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                />
                {showPassword ? (
                  <VisibilityIcon className="eye_visible" onClick={togglePasswordVisibility} />
                ) : (
                  <VisibilityOffIcon className="eye_visible" onClick={togglePasswordVisibility} />
                )}
              </div>
            </div>
            <button type="submit" className="mainButton" disabled={disableBtn}>
              Login
            </button>
          </form>
          )}
        </div>

        <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default Login;
